import type {
  CommonResponseDesignTemplateResponse,
  DesignTemplateWithoutCoverDataResponse,
  GenerateImageUploadPresignedUrlData,
} from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'

import {
  type DesignTemplate,
  DesignTemplateSchema,
  type DesignTemplateSummary,
  DesignTemplateSummarySchema,
  type ImageUploadUrl,
  ImageUploadUrlSchema,
} from './schemas'

const ENTITY = 'DesignTemplate'

// 생성 타입과 실제 와이어가 어긋나는 필드(coverData):
//   schoolType·grade·semester·subject·studentExams — 생성 타입에는 필수로 있지만 서버 CoverData 에 없는 필드다
//   subtitle·academyName·sideTitle·backTopText·backBottomText·frontLogoImage·backLogoImage·salesPrice·width·height
//     — 생성 타입은 optional(키 생략)로 그리지만 서버는 Kotlin nullable 을 키째 null 로 싣는다
// 2026-10-06 백엔드 develop(796cc16ad) workbook/model/dto/CoverData.kt 선언으로 확인. 스키마가 실제 와이어를
// 검증하므로 입력을 이 한 자리에서 unknown 으로 넘긴다.
const asWire = (raw: CommonResponseDesignTemplateResponse['data']): unknown => raw

export const adaptDesignTemplate = (
  raw: CommonResponseDesignTemplateResponse['data'],
): DesignTemplate => parseApiResponse(DesignTemplateSchema, asWire(raw), ENTITY)

export const adaptDesignTemplateSummaries = (
  raw: DesignTemplateWithoutCoverDataResponse[],
): DesignTemplateSummary[] => parseApiResponse(DesignTemplateSummarySchema.array(), raw, ENTITY)

export const adaptImageUploadUrl = (raw: GenerateImageUploadPresignedUrlData): ImageUploadUrl =>
  parseApiResponse(ImageUploadUrlSchema, raw, ENTITY)
